module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("First and foremost, all praise is to my Lord and Savior Christ Jesus who has opened the door of opportunity for this book, and without whose annointing this book cannot reach its full potential any more than I can. Therefore, I praise and thank Him. For my husband, Linwood, who has always done his best for me, professionally and personally, and whose love is one of God’s greatest gifts to me. For my mother, from whom I inherited my humor and mother wit, with which I’ve written much of this book and the wisdom I carried but had not the courage to walk in, in my earlier years. For Pastor Bernard, who has been my spiritual father, giving so much guidance and instruction to bring about the spiritual maturity that I purpose to share herein. For Pastor Johnson, who has been a wonderful mentor, always just a phone call away. For Fippy, Sondra, Darcel, and Bebe, my best friends, who have invested in our friendship, love, encouragement, time, talent, and treasury, above and beyond the call.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fcc4654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 72
// module chunks = 0